let routes = [
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/system/page/About.vue')
  },
  {
    path: '/qrcode',
    name: 'QrCode',
    component: () => import('@/views/system/page/QrCode.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/system/page/Privacy.vue')
  },
  {
    path: '/share1',
    name: 'share1',
    component: () => import('@/views/system/page/Share1.vue')
  },
  {
    path: '/share2',
    name: 'share1',
    component: () => import('@/views/system/page/Share2.vue')
  },
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    component: () => import('@/views/system/page/UserAgreement.vue')
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import('@/views/system/page/Download.vue')
  },
  {
    path: '/transfer',
    name: 'Transfer',
    component: () => import('@/views/system/page/Transfer.vue')
  },
  {
    path: '/pay-code',
    name: 'PayCode',
    component: () => import('@/views/system/page/PayCode.vue')
  },
  {
    path: '/dsfszqd',
    name: 'Dsfszqd',
    component: () => import('@/views/system/page/Dsfszqd.vue')
  },
  {
    path: '/dsfsdk',
    name: 'DsfSDK',
    component: () => import('@/views/system/page/DsfSDK.vue')
  },
  {
    path: '/grxxsjqd',
    name: 'Grxxsjqd',
    component: () => import('@/views/system/page/Grxxsjqd.vue')
  },
  {
    path: '/yyqxsq',
    name: 'Yyqxsq',
    component: () => import('@/views/system/page/Yyqxsq.vue')
  },
  {
    path: '/history-push',
    name: 'HistoryPush',
    component: () => import('@/views/system/page/HistoryPush.vue'),
    meta: {
      title: '历史推送'
    }
  },
  {
    path: '/oauth/authorize',
    name: 'Oauth2Authorize',
    meta: { title: '用户认证协议' },
    component: () => import('@/views/system/page/Authorize.vue')
  },
  {
    path: '/oauth/rule',
    name: 'Oauth2Rule',
    meta: { title: 'APP用户认证协议' },
    component: () => import('@/views/system/page/AuthorizeRule.vue')
  },
  {
    path: '/static-page',
    name: 'HistoryPush',
    component: () => import('@/views/system/page/StaticPage.vue'),
    meta: {
      title: ''
    }
  }
]

routes = [...routes]

export default routes
